import { useLayoutEffect, useRef } from "react";

/** The list comes back as it was left, scrolled where it was. The rows arrive from the API after the browser has already restored
 *  the page's scroll (to a page that was empty then), so the list remembers its own position per address and puts it back once its
 *  rows are there. Whatever scrolls the rows is what is remembered: the body on a phone, the rows' own box wider. A view without a saved
 *  position starts at the top. */
const memory = new Map<string, number>();
/** the nearest ancestor of the rows that scrolls, else the document */
function scroller(): HTMLElement | null {
  const row = document.querySelector<HTMLElement>(".ob-ticket-row"); if (!row) return null;
  for (let el = row.parentElement; el; el = el.parentElement) { const o = getComputedStyle(el).overflowY; if ((o === "auto" || o === "scroll") && el.scrollHeight > el.clientHeight) return el; }
  return document.scrollingElement as HTMLElement | null;
}

export function useListScrollMemory(key: string, showing: boolean, ready: boolean) {
  const restored = useRef<string | null>(null);
  // remember while the list is what the person sees
  useLayoutEffect(() => {
    if (!showing || !ready) return;
    const save = () => { const el = scroller(); if (el) memory.set(key, el.scrollTop); };
    document.addEventListener("scroll", save, { capture: true, passive: true }); // only what the person scrolled: on arrival the page is still where the last screen left it
    return () => document.removeEventListener("scroll", save, { capture: true }); // not saved here: by now the page shows something else
  }, [key, showing, ready]);
  // put it back once: when the list shows again with its rows; a view not visited yet starts at the top (polish round one, 2026-10-16: it
  // used to inherit the last view's position, the list's box being the same element)
  useLayoutEffect(() => {
    if (!showing) { restored.current = null; return; }
    if (!ready || restored.current === key) return;
    restored.current = key;
    const el = scroller(); if (el) el.scrollTop = memory.get(key) ?? 0;
  }, [key, showing, ready]);
}
